'use client';
import React from "react";
import Image from "@/components/atoms/image";
import { Publication } from "@/page-builder/fragments/PublicationBlock/types";
import PlayButton from "@/components/atoms/play-icon";
import { Link } from "@/i18n/navigation";
import { Icon } from "@ama-pt/agora-design-system";

export const VideoCard = ({
  title,
  description,
  featuredImage,
  slug,
  target,
}: Publication) => {
  return (
    <Link title={title} target={target || "_self"} href={'/publicacoes/' + slug as any}>
    <div className="group block overflow-hidden bg-white">
      <article className="flex flex-col h-full">
        <div className="relative w-full aspect-video">
          <Image
            src={featuredImage?.url || ""}
            alt={featuredImage?.alt || ""}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className="object-cover max-h-[280px] h-[280px]"
            priority
            aria-hidden="true"
          />
          <div className="absolute inset-0 z-20 opacity-0 group-hover:opacity-100 transition-opacity bg-bupi-hoverGradient pointer-events-none" />
          <div className="absolute inset-0 z-30 flex items-center justify-center">
            <div className="rounded-full p-3 transform transition-transform duration-200">
              <PlayButton size={40} color="#ffffff" hoverColor="#ffffff" />
            </div>
          </div>
        </div>

        <div className="pt-32 px-16 flex flex-col flex-grow">
          <h2 id={`video-title-${title.replace(/\s+/g, "-").toLowerCase()}`} className="text-l-bold text-neutral-900 line-clamp-2">
            {title}
          </h2>
          <p className="text-m-regular text-neutral-900 mt-8 line-clamp-3 flex-grow ">
            {description}
          </p>
          <div className="mt-16 flex items-center group-hover:opacity-100  justify-between">
            <Icon title="Go" name="agora-line-arrow-right-circle" />
          </div>
        </div>
      </article>
    </div>
    </Link>
  );
};
